import React, { useRef, useEffect, useState } from 'react';
import { useParams, } from "react-router-dom";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { BrCalendar } from './BrCalendar';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

export const TabelaAdubacaoCorrecao = ({ isEditing, adubacaoCorrecao, setAdubacaoCorrecao }) => {
    const toast = useRef(null);
    // eslint-disable-next-line  no-unused-vars
    const [adubacoesCorrecao, setAdubacoesCorrecao] = useState([]);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null);
    const { id } = useParams();
    const formaDose = [
        { label: 'Kg/m²', value: 'KG_M' },
        { label: 'L/m²', value: 'L_M' },
        { label: 'g/Planta', value: 'G_PLANTA' },
    ];
    const formaDoseMapping = {
        'KG_M': 'Kg/m²',
        'L_M': 'L/m²',
        'G_PLANTA': 'g/Planta'
    };
    const formaAplicacao = [
        { label: 'Plantio', value: 'PLANTIO' },
        { label: 'Cobertura', value: 'COBERTURA' },
        { label: 'Foliar', value: 'FOLIAR' },
        { label: 'Fertirrigação', value: 'FERTIRRIGACAO' },
    ];
    const formaAplicacaoMapping = {
        'PLANTIO': 'Plantio',
        'COBERTURA': 'Cobertura',
        'FOLIAR': 'Foliar',
        'FERTIRRIGACAO': 'Fertirrigação'
    };

    /* eslint-disable array-callback-return */

    useEffect(() => {
        const fetchAdubacaoCorrecao = async () => {
            try {
                await getAdubacaoCorrecao();
            } catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        };
        fetchAdubacaoCorrecao();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const getAdubacaoCorrecao = async () => {
        setAdubacoesCorrecao([]);

        try {
            if (isEditing) {
                const response = await api.get(`/caderno/boletimItem/${id}`);
                const cadernoData = response.data;

                if (cadernoData && cadernoData.adubacaoCorrecao) {
                    setAdubacoesCorrecao(cadernoData.adubacaoCorrecao);
                }
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Erro ao obter Adubação Correção', detail: error.toString() });
        }
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button
                    type="button"
                    icon="pi pi-trash"
                    className="p-button-rounded p-mr-2 p-button-danger"
                    loading={isDeleting}
                    onClick={() => handleDeleteClick(rowData)}
                />
            </div>
        );
    }

    const dataAplicacaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Data Aplicação</span>
                    <span className="table-data">
                        {rowData.naoNecessarias ? 'N/A' : new Date(rowData.dataAplicacao).toLocaleDateString('pt-BR')}
                    </span>
                </p>
            </React.Fragment>
        );
    };

    const nomeFormulaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Nome da Fórmula</span>
                    <span className="table-data">{rowData.naoNecessarias ? 'N/A' : rowData.nomeFormula}</span>
                </p>
            </React.Fragment>
        );
    };

    const doseBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Dose</span>
                    <span className="table-data">
                        {rowData.naoNecessarias ? 'N/A' : `${rowData.dose}`}
                    </span>
                </p>
            </React.Fragment>
        );
    };

    const formaDoseBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Forma da Dose</span>
                    <span className="table-data">
                        {rowData.naoNecessarias ? 'N/A' : formaDose.find(f => f.value === rowData.formaDose)?.label || rowData.formaDose}
                    </span>
                </p>
            </React.Fragment>
        );
    };

    const formaAplicacaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Forma de Aplicação</span>
                    <span className="table-data">
                        {rowData.naoNecessarias ? 'N/A' : formaAplicacao.find(f => f.value === rowData.formaAplicacao)?.label || rowData.formaAplicacao}
                    </span>
                </p>
            </React.Fragment>
        );
    };

    const responsavelAplicacaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Responsável pela Aplicação</span>
                    <span className="table-data">{rowData.naoNecessarias ? 'N/A' : rowData.responsavelAplicacao}</span>
                </p>
            </React.Fragment>
        );
    };

    const observacaoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textAlign: 'center' }}>
                    <span className="p-column-title">Observação</span>
                    <span className="table-data">{rowData.naoNecessarias ? 'N/A' : rowData.observacao}</span>
                </p>
            </React.Fragment>
        );
    };

    const handleDeleteClick = (data) => {
        confirmDialog({
            message: `Você tem certeza que quer remover este item?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: () => {
                setIsDeleting(true);
                try {
                    setAdubacaoCorrecao(adubacaoCorrecao.filter(item => item !== data));
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `Item removido com sucesso.` });
                } catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover o item.', detail: error.response.data });
                }
                setIsDeleting(false);
            }
        });
    };

    useEffect(() => {

    }, [adubacaoCorrecao]);

    const onRowEditComplete1 = (e) => {
        let adubacaoCorrecao2 = [...adubacaoCorrecao];
        let { newData, index } = e;
        adubacaoCorrecao2[index] = newData;
        setAdubacaoCorrecao(adubacaoCorrecao2);
    };

    const handleEdit = (data, campo, value) => {
        data[campo] = value;
        setAdubacaoCorrecao([...adubacaoCorrecao]);
    };

    const priceEditorDataAplicacao = (options) => {

        return <BrCalendar
            id="dataAplicacao"
            name="dataAplicacao"
            disabledDays={[]}
            value={new Date(options.rowData.dataAplicacao)}
            onChange={((e) => { handleEdit(options.rowData, 'dataAplicacao', e.value) })}

            readonly={true}

            yearRange={`2010:${new Date().getFullYear() + 3}`}
        />
    }

    const priceEditorNomeFormula = (options) => {
        return <InputText value={options.rowData.nomeFormula} onChange={((e) => { handleEdit(options.rowData, 'nomeFormula', e.target.value) })} />
    }

    const priceEditorDose = (options) => {
        return <InputNumber value={options.rowData.dose} onValueChange={((e) => { handleEdit(options.rowData, 'dose', e.value) })} mode="decimal" min={0} max={9999999} />
    }

    const priceEditorUnidadeDose = (options) => {
        return (
            <Dropdown
                value={options.rowData.formaDose}
                options={formaDose}
                onChange={(e) => handleEdit(options.rowData, 'formaDose', e.value)}
                placeholder="Selecione a Unidade da Dose"
            />
        );
    };

    const priceEditorFormaAplicacao = (options) => {
        return (
            <Dropdown
                value={options.rowData.formaAplicacao}
                options={formaAplicacao}
                onChange={(e) => handleEdit(options.rowData, 'formaAplicacao', e.value)}
                placeholder="Selecione a Forma de Aplicação"
            />
        );
    };

    const priceEditorResponsavelAplicacao = (options) => {
        return <InputText value={options.rowData.responsavelAplicacao} onChange={((e) => { handleEdit(options.rowData, 'responsavelAplicacao', e.target.value) })} />
    }

    const priceEditorObservacao = (options) => {
        return <InputTextarea value={options.rowData.observacao} onChange={((e) => { handleEdit(options.rowData, 'observacao', e.target.value) })} rows={3} />
    }

    return (

        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">

            <Toast ref={toast} position="bottom-right" />

            <Toast ref={confirmationToast} position="bottom-center" />

            <div className="card p-col-12 datatable-responsive-demo">

                <div className="p-fluid">

                    <DataTable

                        editMode="row"
                        onRowEditComplete={onRowEditComplete1}
                        responsiveLayout="scroll"
                        value={adubacaoCorrecao}



                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma informação sobre Adubação e Correção encontrada."
                        dataKey="id"
                        paginator
                        rows={10}
                        currentPageReportTemplate="Mostrando de {first} a {last} de {totalRecords} Adubação e Correção"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 20, 30]}
                        sortField="nome"
                        sortOrder={1}
                        removableSort

                    >

                        <Column
                            field="dataAplicacao"
                            header="Data da aplicação"
                            sortable
                            body={dataAplicacaoBodyTemplate}
                            editor={(options) => priceEditorDataAplicacao(options)}
                            style={{ width: '12%' }}
                        />

                        <Column
                            field="nomeFormula"
                            header="Nome do Produto/Fórmula"
                            sortable
                            body={nomeFormulaBodyTemplate}
                            editor={(options) => priceEditorNomeFormula(options)}
                            style={{ width: '12%' }}

                        />

                        <Column
                            field="doseBodyTemplate"
                            header="Dose"
                            sortable
                            body={doseBodyTemplate}
                            editor={(options) => priceEditorDose(options)}
                            style={{ width: '12%' }}

                        />

                        <Column
                            field="formaDose"
                            header="Forma de dose"
                            sortable
                            body={formaDoseBodyTemplate}
                            editor={(options) => priceEditorUnidadeDose(options)}
                            style={{ width: '12%' }}

                        />

                        <Column
                            field="formaAplicacao"
                            header="Forma de aplicação"
                            sortable
                            body={formaAplicacaoBodyTemplate}
                            editor={(options) => priceEditorFormaAplicacao(options)}
                            style={{ width: '12%' }}

                        />

                        <Column
                            field="responsavelAplicacao"
                            header="Responsável pela aplicação"
                            sortable
                            body={responsavelAplicacaoBodyTemplate}
                            editor={(options) => priceEditorResponsavelAplicacao(options)}
                            style={{ width: '12%' }}

                        />

                        <Column
                            field="observacao"
                            header="Observação"
                            body={observacaoBodyTemplate}
                            editor={(options) => priceEditorObservacao(options)}
                            style={{ width: '12%' }}

                        />

                        <Column
                            rowEditor
                            headerStyle={{ width: '10%', minWidth: '8rem' }}
                            bodyStyle={{ textAlign: 'center' }}>
                        </Column>




                        <Column
                            header="Ações"
                            body={actionBodyTemplate}

                        />

                    </DataTable>

                </div>
            </div>
        </div>

    );
}
